import { Component, computed, effect, Inject, inject, OnInit, PLATFORM_ID, signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { enableElfProdMode } from '@ngneat/elf';
import { AnimationOptions, LottieComponent } from 'ngx-lottie';
import { Toast, ToastPositionType } from 'primeng/toast';
import { environment } from 'src/environments/environment';
import { LOTTIES } from './shared/lotties';
import { LoadingService } from '@services/loading.service';
import { ToastService } from '@services/toast.service';
import { MessageService } from 'primeng/api';
import { GoogleMapsService } from '@services/google-maps.service';
import { isPlatformBrowser } from '@angular/common';
import { CatalogsStore } from '@store/catalogs.store';
import { CatalogsService } from '@services/catalogs.service';
import { catchError, forkJoin, of } from 'rxjs';

@Component({
  selector: 'app-root',
  imports: [
    RouterOutlet,
    LottieComponent,
    Toast,
  ],
  templateUrl: './app.html',
  styleUrl: './app.scss',
  providers: [MessageService, ToastService]
})
export class App implements OnInit {

  public lottieLoader: AnimationOptions = {
    loop: true,
    path: LOTTIES.loader
  };

  public position = signal<ToastPositionType>('bottom-center');

  private loadingService = inject(LoadingService);
  private toastService = inject(ToastService);
  private messageService = inject(MessageService);
  private mapsService = inject(GoogleMapsService);

  public itsLoading = this.loadingService.itsLoading;
  public readonly toastVisible = computed(() => this.toastService.toast() != null);

  private catalogsStore = inject(CatalogsStore);
  private catalogsService = inject(CatalogsService);

  constructor(
    @Inject(PLATFORM_ID) private platformId: Object
  ) {

    if (environment.production) {
      enableElfProdMode();
    }

    effect(() => {
      const toast = this.toastService.toast();
      if (toast) {
        this.position.set(this.toastService.toastPosition());
        this.messageService.add({ ...toast, key: 'myGlobalToast', closable: true });
      }
    });

  }

  ngOnInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      this.mapsService.loadGoogleMaps();
    }

    this.loadCategoriesAndBrands();
  }

  public clearToast() {
    this.messageService.clear();
    this.toastService.clear();
  }

  private loadCategoriesAndBrands() {
    forkJoin({
      categories: this.catalogsService.getCategories(),
      brands: this.catalogsService.getBrands().pipe(catchError(() => of([])))
    }).subscribe({
      next: ({ categories, brands }) => {
        this.catalogsStore.initCategories(categories, brands);
      },
      error: (err) => {
        this.toastService.showToast('error.defaultError', 'catalogs.errorLoadingCatalog', 'error');
      }
    });
  }
}
